import type { RootState } from 'store/store';

type FFSelectorState = Pick<RootState, 'featureFlags'>;

export const isFeatureFlagEnabled =
  (ffName: string) =>
  (store: FFSelectorState): boolean => {
    return store.featureFlags[ffName];
  };

export const featureFlagsSelectors = {
  isFeatureFlagEnabled,
  /**
   * Convenience selector for surcharge PDT global flag
   */
  isSurchargePaintedDoorEnabled: (store: FFSelectorState): boolean => {
    return store?.featureFlags?.['cp-enabled-surcharge-painted-door-test'];
  },
};
